module.exports = __webpack_public_path__ + "static/Aboleth-f83d1c35aa2da208d11140064f948b57.jpg";